import gsap from 'gsap'

import { getScrollTriggerOptions } from './shared'
import { Animation } from '@/types'

export const heroRevealAnimation = ({ nodeRef, context, reverse }: Animation) => {
  const title = context.selector?.('[data-motion-title]')
  const text = context.selector?.('[data-motion-text]')
  const primaryButton = context.selector?.('[data-motion-button-primary]')
  const secondaryButton = context.selector?.('[data-motion-button-secondary]')

  const timeline = gsap
    .timeline({
      delay: 0.2,
      ...getScrollTriggerOptions(nodeRef, reverse)
    })
    .add(
      gsap
        .timeline()
        .fromTo(
          [...title, ...text, ...primaryButton, ...secondaryButton],
          { opacity: 0, y: 30 },
          { opacity: 1, y: 0, duration: 1.2, ease: 'power3.out', stagger: { amount: 0.3 } }
        ),
      0
    )

  return () => {
    timeline.kill()
  }
}
